import React from 'react';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import styles from './Popover.module.css';

const Popover = (
  props,
) => {
  return (
    <>
      {[
        'success',
      ].map((variant) =>
      (
        <Alert
          dismissible={false}
          show={props.isOpen}
          key={variant}
          variant={variant}
          className={styles.informationBox}
        >
          {props.warningTitle}
        </Alert>
      )
      )}
    </>
  );
}

Popover.propTypes = {
  warningTitle: PropTypes.string,
};
Popover.defaultProps = {};

export default Popover;
